import { graphql, useStaticQuery } from "gatsby"
import React, { useState, useEffect } from "react"
import { Box, Flex } from "theme-ui"

const reactionQuery = graphql`
  query {
    site {
      siteMetadata {
        reaction {
          id
          title
        }
      }
    }
  }
`

const Reactions = ({ page }) => {
  const [pathname, setPathname] = useState(page)

  const data = useStaticQuery(reactionQuery)
  let title = "Did you enjoy this chapter?"
  let id = "e7e9ae80-73ac-45e7-84e0-38fc6b5443b1"
  if (data.site.siteMetadata.reaction) {
    title = data.site.siteMetadata.reaction.title
    id = data.site.siteMetadata.reaction.id
  }

  useEffect(() => {
    if (typeof window !== "undefined") {
      setPathname(window.location.pathname)
    }
  }, [])

  return (
    <Flex sx={{ alignItems: "center", mb: [2, 3, 3] }}>
      <h4 style={{ margin: 0 }}>{title}</h4>
      <Box
        sx={{
          pl: 3,
          "& a": {
            fontSize: 26,
            pr: 1,
            textDecoration: "none",
          },
        }}
      >
        <a
          href={`https://spark-joy.netlify.app/${id}/thumbsdown?instanceOfJoy=${pathname}`}
        >
          <span role="img" aria-label="thumbs-down">
            👎
          </span>
        </a>
        <a
          href={`https://spark-joy.netlify.app/${id}/thumbsup?instanceOfJoy=${pathname}`}
        >
          <span role="img" aria-label="thumbs-up">
            👍
          </span>
        </a>
      </Box>
    </Flex>
  )
}

export default Reactions
